import { InnerBlocks, InspectorControls } from "@wordpress/block-editor";
import { PanelBody, SelectControl, ToggleControl } from "@wordpress/components";
import { useState } from "@wordpress/element";

wp.blocks.registerBlockType("meetravel/section-container", {
    title: "Sezione",
    description: "Il blocco sezione che contiene tutti gli altri blocchi e abilita lo sfondo grigio alternato",
    category: "layout",
    icon: "block-default",
    attributes: {
        justifyContent: {
            type: "string",
            default: "flex-start",
        },
        flexDirection: {
            type: "string",
            default: "row",
        },
        greyBackground: {
            type: "boolean",
            default: false,
        },
    },

    edit(props) {
        const { attributes, setAttributes } = props;
        const { justifyContent, flexDirection, greyBackground } = attributes;

        // Funzioni per aggiornare gli attributi
        const onChangeJustifyContent = (newValue) => {
            setAttributes({ justifyContent: newValue });
        };

        const onChangeFlexDirection = (newValue) => {
            setAttributes({ flexDirection: newValue });
        };

        const onToggleGreyBackground = () => {
            setAttributes({ greyBackground: !greyBackground });
        };

        return (
            <>
                <InspectorControls>
                    <PanelBody title="Impostazioni Flexbox">
                        <SelectControl
                            label="Allineamento degli elementi (justify-content)"
                            value={justifyContent}
                            options={[
                                { label: "Inizio", value: "flex-start" },
                                { label: "Centro", value: "center" },
                                { label: "Fine", value: "flex-end" },
                                { label: "Spazio tra gli elementi", value: "space-between" },
                                { label: "Spazio intorno agli elementi", value: "space-around" },
                                { label: "Spazio uniforme tra gli elementi", value: "space-evenly" },
                            ]}
                            onChange={onChangeJustifyContent}
                        />
                        <SelectControl
                            label="Direzione del Flexbox"
                            value={flexDirection}
                            options={[
                                { label: "Riga", value: "row" },
                                { label: "Riga inversa", value: "row-reverse" },
                                { label: "Colonna", value: "column" },
                                { label: "Colonna inversa", value: "column-reverse" },
                            ]}
                            onChange={onChangeFlexDirection}
                        />
                        <ToggleControl
                            label="Sfondo grigio"
                            checked={greyBackground}
                            onChange={onToggleGreyBackground}
                        />
                    </PanelBody>
                </InspectorControls>
                <section
                    className={greyBackground ? "grey-background" : ""}
                    style={{
                        display: "flex",
                        justifyContent: justifyContent,
                        flexDirection: flexDirection,
                    }}
                >
                    <InnerBlocks />
                </section>
            </>
        );
    },

    save(props) {
        const { attributes } = props;
        const { justifyContent, flexDirection, greyBackground } = attributes;

        return (
            <section
                className={greyBackground ? "grey-background" : ""}
                style={{
                    display: "flex",
                    justifyContent: justifyContent,
                    flexDirection: flexDirection,
                }}
            >
                <InnerBlocks.Content />
            </section>
        );
    },
});
